let _ctx: AudioContext | null = null;
const getCtx = (): AudioContext => {
  if (!_ctx) _ctx = new AudioContext();
  if (_ctx.state === 'suspended') void _ctx.resume();
  return _ctx;
};

const tone = (
  ctx: AudioContext,
  freq: number,
  start: number,
  duration: number,
  gain: number,
  type: OscillatorType = 'sine'
): void => {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.connect(g);
  g.connect(ctx.destination);
  osc.type = type;
  osc.frequency.setValueAtTime(freq, start);
  g.gain.setValueAtTime(0, start);
  g.gain.linearRampToValueAtTime(gain, start + 0.01);
  g.gain.exponentialRampToValueAtTime(0.001, start + duration);
  osc.start(start);
  osc.stop(start + duration + 0.02);
};

// Success Sound
export const playGoodSound = (): void => {
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 880, t, 0.12, 0.25);
    tone(ctx, 1108, t + 0.1, 0.18, 0.25);
  } catch {
    // Silently ignore if audio unavailable
  }
};

// Error Sound (during problem or exception)
export const playErrorSound = (): void => {
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 300, t, 0.18, 0.4, 'sawtooth');
    tone(ctx, 200, t + 0.2, 0.25, 0.4, 'sawtooth');
  } catch {
    // Silently ignore if audio unavailable
  }
};

// Callback item detected
export const playCallbackSound = (): void => {
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 880, t, 0.08, 0.45, 'square');
    tone(ctx, 880, t + 0.13, 0.08, 0.45, 'square');
    tone(ctx, 1320, t + 0.28, 0.18, 0.45, 'square');
  } catch {
    // Silently ignore if audio unavailable
  }
};

export const playHoldSound = (): void => {
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 440, t, 0.12, 0.25);
    tone(ctx, 330, t + 0.1, 0.18, 0.25);
  } catch {
    // Silently ignore if audio unavailable
  }
};

// Receipt auto-closed fanfare
export const playFanfareSound = (): void => {
  try {
    const ctx = getCtx();
    const t = ctx.currentTime;
    tone(ctx, 523, t, 0.12, 0.3, 'triangle');
    tone(ctx, 659, t + 0.12, 0.12, 0.3, 'triangle');
    tone(ctx, 784, t + 0.24, 0.12, 0.3, 'triangle');
    tone(ctx, 1047, t + 0.36, 0.5, 0.3, 'triangle');
    tone(ctx, 784, t + 0.36, 0.5, 0.2, 'triangle');
    tone(ctx, 659, t + 0.36, 0.5, 0.2, 'triangle');
  } catch {
    // Silently ignore if audio unavailable
  }
};
